import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {ReactQueryDevtools} from '@tanstack/react-query-devtools';
import React from 'react';

const queryClient = new QueryClient({
    defaultOptions: {
        // changing the stale time to infinity means that react query will not automatically refetch
        // data on subsequent mounts, window focuses or network reconnects.
        //
        // i'm doing this because our data doesn't need to have real-time updates or frequent
        // refreshes. the app hasn't had automatic refetches for 7 years and it didn't seem to be a
        // problem.
        queries: {
            staleTime: Infinity,
            retry(failureCount, error) {
                // dont retry any 404s
                //
                // our api doesn't return standardised errors, so sometimes a 404 is on the
                // statusCode and sometimes it isnt
                if (error.message.includes('404') || error.statusCode === 404) {
                    return false;
                }
                // retry once
                return failureCount < 1;
            }
        }
    }
});

export default function ReactQueryProvider(props: {children: React.ReactNode}) {
    return (
        <QueryClientProvider client={queryClient}>
            {props.children}
            <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
        </QueryClientProvider>
    );
}
